import {
  Component,
  Output,
  EventEmitter,
  Input,
  OnChanges
} from '@angular/core'

/**
 * Component that provide a selector for selecting a language.
 * Uses flags of countries
 */
@Component({
    selector: 'aio-lang-selector',
    templateUrl: './lang-selector.component.html',
    styleUrls: ['./lang-selector.component.sass'],
    standalone: false
})
export class LangSelectorComponent implements OnChanges {
  /**
   * Should selector show itself
   */
  public selecting = false

  /**
   * Available languages
   */
  public languages = ['fr', 'en']

  /**
   * Selectable languages
   */
  public selectableLanguages = []

  /**
   * Previously selected language
   */
  @Input() selected = 'fr'
  /**
   * Emits new selected language
   */
  @Output() selectLanguage: EventEmitter<string> = new EventEmitter()

  ngOnChanges() {
    this.selectableLanguages = this.languages.filter((l) => l !== this.selected)
  }

  /**
   * Toggles show/hide of selector list
   */
  toggleSelect() {
    this.selecting = !this.selecting
  }

  /**
   * Closes selector list
   */
  closeSelect() {
    this.selecting = false
  }

  /**
   * Updates selected language
   */
  setSelected(value: string) {
    this.selected = value
    this.selectableLanguages = this.languages.filter((l) => l !== value)
    this.selectLanguage.emit(value)
  }
}
